import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";

interface SessionRefreshModalProps {
  open: boolean;
  onRefresh: () => void;
}

export function SessionRefreshModal({
  open,
  onRefresh,
}: SessionRefreshModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={() => { }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("Sessione scaduta")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            {t(
              "La tua sessione è scaduta. Per continuare, aggiorna la pagina."
            )}
          </p>
          <div className="flex justify-end space-x-2">
            <Button variant="secondary" onClick={onRefresh}>
              {t("Aggiorna pagina")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
